var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseRotateLeftdrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes clickHold {\n      0%, 5% { fill: #888; }\n      8% { fill: #444; }\n      18% { fill: #444; }\n      20%, 55% { fill: #444; }\n      58%, 100% { fill: #888; }\n    }\n    @keyframes ringHold {\n      0%, 5% { opacity: 0; r: 6; }\n      10% { opacity: 0.8; r: 6; }\n      55% { opacity: 0.5; r: 6; }\n      60% { opacity: 0; r: 6; }\n      100% { opacity: 0; }\n    }\n    @keyframes slideX {\n      0%, 18% { transform: translateX(0); }\n      34% { transform: translateX(22px); }\n      50% { transform: translateX(-22px); }\n      58% { transform: translateX(0); }\n      65%, 100% { transform: translateX(0); }\n    }\n    .lb { animation: clickHold 4s ease-in-out infinite; }\n    .cr { animation: ringHold 4s ease-in-out infinite; }\n    .mg { animation: slideX 4s ease-in-out infinite; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "mg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 52,
    width: 84,
    height: 136,
    rx: 42,
    ry: 42,
    fill: "#888",
    stroke: "#999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "lb",
    d: "M120,52 A42,42 0 0,0 78,94 L78,108 L120,108 Z",
    stroke: "#999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 52,
    x2: 120,
    y2: 108,
    stroke: "#999",
    strokeWidth: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 78,
    width: 16,
    height: 36,
    rx: 8,
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cr",
    cx: 100,
    cy: 82,
    r: 6,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseRotateLeftdrag);
export default __webpack_public_path__ + "static/media/mouse-rotate-leftdrag.f20a43a40a30a2ee20f813138c1cd9f6.svg";
export { ForwardRef as ReactComponent };